import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getEventByIdAdmin } from "../../api/plan";
// import { getTicketsByEventId, deleteTicketById } from "../../api/ticket";
import { useForm } from "react-hook-form";
import { jwtDecode } from "jwt-decode";
import TicketTable from "./TicketTable";
import DashboardLayout from "./components/Layout";
import { deleteTicket } from "../../api/subscription";

const TicketsPage = () => {
  const { eventId: id } = useParams();

  const navigate = useNavigate();
  const [eventData, setEventData] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [ticketTypeFilter, setTicketTypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("success");
  const [paidByFilter, setPaidByFilter] = useState("");

  const { register, handleSubmit, control, reset } = useForm();
  const decoded = jwtDecode(localStorage.getItem("auth"));

  useEffect(() => {
    if (decoded?.type !== "event-admin") {
      window.location.replace("/");
    }
  }, [decoded]);

  const fetchEventData = async (id) => {
    const response = await getEventByIdAdmin(id);
    setEventData(response?.data?.data);
  };

  useEffect(() => {
    if (id) {
      fetchEventData(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onDelete = async (eventId, ticketId) => {
    const confirmed = window.confirm("Bu bileti silmək istədiyinizə əminsiniz?");
    if (confirmed) {
      try {
        await deleteTicket(eventId, ticketId);
        fetchEventData(eventId); // Silmədən sonra siyahını yenilə
      } catch (error) {
        console.error("Bilet silinərkən xəta baş verdi:", error);
        alert("Silinmə zamanı xəta baş verdi.");
      }
    }
  };

  return (
    <DashboardLayout id={id}>
        {id && (
          <main className="flex-1 bg-gray-100">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800">📄 Bilet Siyahısı</h2>
              <Link
                to={`/dashboard/${id}/tickets/new`}
                className="bg-gray-800 text-white px-5 py-2 rounded-md hover:bg-gray-700 transition"
              >
                Yeni Bilet
              </Link>
            </div>

            {/* Ticket Table */}
            <TicketTable
              eventId={id}
              tickets={eventData?.tickets}
              onDelete={onDelete}
              ticketTypeFilter={ticketTypeFilter}
              setTicketTypeFilter={setTicketTypeFilter}
              statusFilter={statusFilter}
              paidByFilter={paidByFilter}
              setStatusFilter={setStatusFilter}
              setPaidByFilter={setPaidByFilter}
            />
		</main>)}
	</DashboardLayout>
  );
};

export default TicketsPage;
